import React from 'react';

const DownloadTheApp = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white py-10 px-8">
      <div className="container mx-auto text-center">
        <h1 className="text-4xl md:text-6xl font-bold mt-20 mb-8">Looking for the app?</h1>
        <p className="text-lg md:text-2xl mb-12">Get the app on your favorite platform and start connecting with your church community today!</p>
        <div className="flex flex-wrap justify-center gap-8">
            <div className="w-full md:w-1/3 bg-gray-800 p-6 rounded-3xl shadow-lg mb-20">
                <img 
                src="assets/images/joltchat_app_icon.png" 
                alt="JoltChat app icon" 
                className="w-32 mx-auto my-4 rounded-3xl" 
                />
                <h2 className="text-3xl font-bold mb-4">Download JoltChat</h2>

                <div className="flex flex-col justify-center items-center p-4 bg-gray-700/30 rounded-xl">
                <a 
                    href="https://apps.apple.com/us/app/joltchat/id6475605931" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-52 transform hover:scale-105 transition-transform duration-200"
                >
                    <img 
                    src="/assets/images/apple-download.png" 
                    alt="Get it on iOS" 
                    className="w-full h-auto drop-shadow-md" 
                    />
                </a>
                <a 
                    href="https://play.google.com/store/apps/details?id=com.JoltChat.app" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-48 transform hover:scale-105 transition-transform duration-200"
                >
                    <img 
                    src="/assets/images/google-download.png" 
                    alt="Get it on Google Play" 
                    className="w-full h-auto drop-shadow-md"
                    />
                </a>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadTheApp;